export const buttonStyles = {
  components: {
    Button: {
      variants: {
        "no-hover": {
          _hover: {
            boxShadow: "none",
          },
        },
        "transparent-with-icon": {
          bg: "transparent",
          fontWeight: "bold",
          borderRadius: "inherit",
          cursor: "pointer",
          _hover: "none",
          _active: {
            bg: "transparent",
            transform: "none",
            borderColor: "transparent",
          },
          _focus: {
            boxShadow: "none",
          },
        },
        brand: {
          bg: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
          color: "#fff",
          boxShadow: "0 4px 14px rgba(34, 197, 94, 0.25)",
          _hover: {
            bg: "linear-gradient(135deg, #4ade80 0%, #22c55e 100%)",
            boxShadow: "0 6px 20px rgba(34, 197, 94, 0.35)",
            transform: "translateY(-1px)",
          },
          _active: {
            bg: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
            transform: "translateY(0)",
          },
          _focus: {
            boxShadow: "none",
          },
          transition: "all 0.2s ease",
        },
        outlineWhite: {
          bg: "transparent",
          color: "#fff",
          borderColor: "white",
          borderWidth: "1px",
          _hover: {
            bg: "whiteAlpha.100",
          },
          _active: {
            bg: "whiteAlpha.200",
          },
          _focus: {
            boxShadow: "none",
          },
        },
      },
      baseStyle: {
        borderRadius: "12px",
        _focus: {
          boxShadow: "none",
        },
        _active: {
          boxShadow: "none",
        },
      },
    },
  },
};
